// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-episode-tsx": function componentSrcEpisodeTsx() {
    return import("./../../src/Episode.tsx"
    /* webpackChunkName: "component---src-episode-tsx" */
    );
  },
  "component---src-pages-about-tsx": function componentSrcPagesAboutTsx() {
    return import("./../../src/pages/about.tsx"
    /* webpackChunkName: "component---src-pages-about-tsx" */
    );
  },
  "component---src-pages-episodes-tsx": function componentSrcPagesEpisodesTsx() {
    return import("./../../src/pages/episodes.tsx"
    /* webpackChunkName: "component---src-pages-episodes-tsx" */
    );
  },
  "component---src-pages-index-tsx": function componentSrcPagesIndexTsx() {
    return import("./../../src/pages/index.tsx"
    /* webpackChunkName: "component---src-pages-index-tsx" */
    );
  },
  "component---src-pages-recipes-tsx": function componentSrcPagesRecipesTsx() {
    return import("./../../src/pages/recipes.tsx"
    /* webpackChunkName: "component---src-pages-recipes-tsx" */
    );
  },
  "component---src-recipe-tsx": function componentSrcRecipeTsx() {
    return import("./../../src/Recipe.tsx"
    /* webpackChunkName: "component---src-recipe-tsx" */
    );
  }
};